module.exports = __webpack_public_path__ + "static/uv-device-2f8b45b4e5586a3c294f1e0f60dd00fc.png";